import { types } from "../types/types";

export const focusSet = (payload) => ({
    type: types.focusSet,
    payload,
});

export const focusClear = (payload) => ({
    type: types.focusClear,
    payload,
});

export const focusPrune = () => ({
    type: types.focusPrune,
});
